import { axiosInstance } from './axiosInstance'
import * as constants from '../state/constants/apiConstants'

class WebinarService {
	static postRegisterProspect(idWebinar, payload) {
		return axiosInstance
			.post(constants.WEBINAR_PROSPECT + '?event=' + idWebinar, payload)
			.then(resp => resp.data)
	}

	static payOTP(payload) {
		return axiosInstance
			.post(constants.WEBINAR_OTP, payload)
			.then(resp => resp.data)
	}

	static validateOTP(code, user) {
		return axiosInstance
			.get(constants.WEBINAR_OTP_VALIDATE + '?code=' + code + '&user=' + user)
			.then(resp => resp.data)
	}

	static getCertificate(code, user, config) {
		return axiosInstance
			.get(
				constants.WEBINAR_CERTIFICATE + '?eventCode=' + code + '&user=' + user,
				config
			)
			.then(resp => resp)
	}

	static validateEmail(payload) {
		return axiosInstance
			.post(constants.WEBINAR_EMAIL_VALIDATE, payload)
			.then(resp => resp)
	}

	static postView(payload) {
		return axiosInstance.post(constants.EVENT_READ, payload).then(resp => resp)
	}

	static getViews() {
		return axiosInstance.get(constants.EVENT_READ).then(resp => resp.data)
	}
}

export default WebinarService
